import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";

const FlowActionsContext = createContext(null);

export function FlowActionsProvider({ children }) {
  const controllers = useRef(new Map());
  const [ready, setReady] = useState(false);
  const updateReady = useCallback(() => {
    setReady(["1", "2", "3", "4", "5", "6", "core"].every(id => controllers.current.get(id)?.ready));
  }, []);
  const register = useCallback((id, controller) => {
    controllers.current.set(id, controller);
    updateReady();
    return () => { controllers.current.delete(id); updateReady(); };
  }, [updateReady]);
  const apply = useCallback((action) => {
    controllers.current.forEach((controller) => controller[action]());
  }, []);
  const value = useMemo(() => ({ register, apply, ready }), [register, apply, ready]);
  return <FlowActionsContext.Provider value={value}>{children}</FlowActionsContext.Provider>;
}

export function useFlowActions() {
  return useContext(FlowActionsContext);
}
